<div class="auxiliary-panel-container">

  <div class="panel-el">

    <div class="el-title">
      <img src="assets/img/megaphone.svg" alt=""/>
      <span>ÐÐ±ÑÑÐ²Ð»ÐµÐ½Ð¸Ñ</span>
    </div>

    <div class="el-description">
      Ð¡Ð¾Ð·Ð´Ð°ÑÑ Ð½Ð¾Ð²Ð¾Ðµ
    </div>
  </div>

  <div class="panel-el">

    <div class="el-title">
      <span>Ð£ÑÐ»ÑÐ³Ð¸</span>
    </div>

    <div class="el-description">
      ÐÐ°ÑÑÑÐ¾Ð¸ÑÑ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ ÑÑÐ»ÑÐ³
    </div>
  </div>

  <div class="panel-el">

    <div class="el-title">
      <img src="assets/img/messenger.svg" alt=""/>
      <span>Ð§Ð°ÑÑ</span>
    </div>

    <div class="el-description">
      ÐÐ°Ð¿Ð¸ÑÐ°ÑÑ
    </div>
  </div>
</div>
